export default function noop() {
  // Do nothing
}



// WEBPACK FOOTER //
// ./src/site-render/src/lib/noop.js